import digitalDataActionTypes from '../actionTypes/DigitalDataActionTypes';

const snapshotDigitalData = () => ({
    type: digitalDataActionTypes.SNAPSHOT_DIGITAL_DATA,
});

export default snapshotDigitalData;
